import { render, staticRenderFns } from "./Row.vue?vue&type=template&id=f5313134"
import script from "./Row.vue?vue&type=script&lang=js"
export * from "./Row.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f5313134')) {
      api.createRecord('f5313134', component.options)
    } else {
      api.reload('f5313134', component.options)
    }
    module.hot.accept("./Row.vue?vue&type=template&id=f5313134", function () {
      api.rerender('f5313134', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/scholarship/loadingProcess/components/Row.vue"
export default component.exports